import { render, staticRenderFns } from "./download.page.vue?vue&type=template&id=63345711&scoped=true&"
import script from "./download.page.vue?vue&type=script&lang=js&"
export * from "./download.page.vue?vue&type=script&lang=js&"
import style0 from "./download.page.vue?vue&type=style&index=0&id=63345711&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63345711",
  null
  
)

export default component.exports